import { Box, Flex } from "@chakra-ui/react";
import { APP_PLATFORM } from "../../config";
import { Platform } from "../../models";
import { Content } from "../Content";
import { Header } from "../Header";
import { Sidebar } from "../Sidebar";
import IFrameComponent from "./IFrameComponent";
import { Typography, Modal } from "@reconvert/react-ui-component";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useCallback, useState, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { selectUnsavedState, setShowUnSaveModelInfo } from "../../app/slice/unsavedSlice";
import useUnsavedBar from "../../hooks/useUnsavedBar";
import ReviewStickyWidgetV2 from "../ReviewCollector/ReviewStickyWidgetV2";
import WelcomePage from "../WelcomePage";
import { useLocation } from "react-router-dom";
import { useDirection } from "../../hooks/useDirection";
import HelpModal from "../HelpModal/HelpModal";
import { selectAppState, setShowFlowBuilder } from "../../app/slice/appSlice";
import { callHandleOnSubmit } from "../../utils/conditionSubmitHandler";

const PageLayout = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const showWelcomePage = queryParams.get("showWelcomePage") || "";
  const { t } = useTranslation();
  const { showFlowBuilder } = useAppSelector(selectAppState);
  const { showUnSaveModelInfo, isConditionCreateOrUpdate } = useAppSelector(selectUnsavedState);
  const { handleDiscard, handleSave } = useUnsavedBar();

  const { direction } = useDirection();
  const closeUnSavedModal = useCallback(() => {
    dispatch(setShowUnSaveModelInfo({ callback: () => { } }));
  }, [dispatch]);


  useEffect(() => {
    if (showWelcomePage === "true") {
      dispatch(setShowFlowBuilder(false));
    }
  }, [showWelcomePage]);

  
  
  const handleSaveClick = async () => {
    if (isConditionCreateOrUpdate) {
      callHandleOnSubmit();
      closeUnSavedModal();
      return;
    }
    
    const response = await handleSave();

    response && showUnSaveModelInfo?.callback();
    closeUnSavedModal();
  }
  const handleDiscardClick = () => {
    handleDiscard();
    showUnSaveModelInfo.callback();
    closeUnSavedModal();
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        height: "100vh",
      }}
    >
      {APP_PLATFORM === Platform.Wix && <Header />}
      <Flex flex={1} minHeight={0}>
        <Sidebar />
        {APP_PLATFORM === Platform.Shopify && <ReviewStickyWidgetV2 />}
        {!showFlowBuilder && APP_PLATFORM === Platform.Shopify ? <WelcomePage /> : <Content />}
      </Flex>
      <IFrameComponent />
      <Modal
        title={t('Would you like to save your changes?')}
        okButton={{
          text: t("Save"),
          onClick: handleSaveClick,
          variant: "primary",
        }}
        cancelButton={{
          text: t("Discard"),
          onClick: handleDiscardClick,
          variant: "secondary",
        }}
        size={"2xl"}
        isOpen={showUnSaveModelInfo.open}
        onClose={closeUnSavedModal}
        direction={direction}
      >
        <Typography variant="body-16-regular">
          {t('Warning: Clicking discard at this stage will delete any unsaved changes')}
        </Typography>
      </Modal>
      <HelpModal />
    </Box>
  );
};

export default PageLayout;
